// opervex-frontend/src/Opervex/MaterialManagement/StockSerial.js

class StockSerial {
  #_api;

  constructor(api) {
    this.#_api = api;
  }

  async findByProductDeposit(product, deposit) {
    return this.#_api.get(`/MaterialManagement/StockSerial?product=${product}&deposit=${deposit}`);
  }
}

// Export the class itself (not an instance)
export default StockSerial;
